module.exports = __webpack_public_path__ + "static/media/fe_resized.286b4cf6.png";